import { render, staticRenderFns } from "./PagesCountRegionReportComponent.vue?vue&type=template&id=1ad5775e&scoped=true"
import script from "./PagesCountRegionReportComponent.vue?vue&type=script&lang=js"
export * from "./PagesCountRegionReportComponent.vue?vue&type=script&lang=js"
import style0 from "./PagesCountRegionReportComponent.vue?vue&type=style&index=0&id=1ad5775e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad5775e",
  null
  
)

export default component.exports